import { SystemRole } from '../Enums/system-role.enum';

export const ROLE_SUBSCRIPTION_CONTROL = SystemRole.BACKOFFICE_BILLING_ADMIN;

export const OFFER_TYPE_MONTHLY = 'monthly';

export const OFFER_TYPE_COMMIT12 = 'commit12';

export const OFFER_TYPE_OPTIONS: readonly string[] = [OFFER_TYPE_MONTHLY, OFFER_TYPE_COMMIT12];

export const OFFER_TYPE_LABEL: Readonly<Record<string, string>> = {
  [OFFER_TYPE_MONTHLY]: 'backoffice.enums.offer_type.monthly',
  [OFFER_TYPE_COMMIT12]: 'backoffice.enums.offer_type.commit12',
};

export const CANCEL_MODE_AT_PERIOD_END = 'at_period_end';

export const CANCEL_MODE_IMMEDIATE = 'immediate';

export const CANCEL_MODE_OPTIONS: readonly string[] = [
  CANCEL_MODE_AT_PERIOD_END,
  CANCEL_MODE_IMMEDIATE,
];

export const CANCEL_MODE_LABEL: Readonly<Record<string, string>> = {
  [CANCEL_MODE_AT_PERIOD_END]: 'backoffice.enums.cancel_mode.at_period_end',
  [CANCEL_MODE_IMMEDIATE]: 'backoffice.enums.cancel_mode.immediate',
};

export const CANCEL_MODE_CONSEQUENCE: Readonly<Record<string, string>> = {
  [CANCEL_MODE_AT_PERIOD_END]: 'backoffice.enums.cancel_mode_consequence.at_period_end',
  [CANCEL_MODE_IMMEDIATE]: 'backoffice.enums.cancel_mode_consequence.immediate',
};

export const TRIAL_MAX_DAYS = 90;

export const REASON_MAX = 500;

export const OVERRIDE_AMOUNT_MAX = 100000;

export const CHANGE_CONFIRM_TITLE = 'backoffice.subscriptions.change.confirm_title';

export const CHANGE_CONSEQUENCE_KEY = 'backoffice.subscriptions.change.consequence';

export const CHANGE_CHARGES_NOW = 'backoffice.subscriptions.change.charges_now';

export const CHANGE_CHARGES_NOTHING = 'backoffice.subscriptions.change.charges_nothing';

export const CHANGE_PREVIEW_REQUIRED = 'backoffice.subscriptions.change.preview_required';

export const CHANGE_AMOUNT_SUMMARY_KEY = 'backoffice.subscriptions.change.amount_summary';

export const CHANGE_AMOUNT_DUE_LABEL = 'backoffice.subscriptions.change.amount_due';

export const CHANGE_APPLIED_MESSAGE = 'backoffice.subscriptions.change.applied';

export const PAUSE_CONFIRM_TITLE = 'backoffice.subscriptions.actions.pause_title';

export const PAUSE_CONSEQUENCE = 'backoffice.subscriptions.actions.pause_consequence';

export const PAUSE_APPLIED_MESSAGE = 'backoffice.subscriptions.actions.paused';

export const RESUME_CONFIRM_TITLE = 'backoffice.subscriptions.actions.resume_title';

export const RESUME_CONSEQUENCE = 'backoffice.subscriptions.actions.resume_consequence';

export const RESUME_APPLIED_MESSAGE = 'backoffice.subscriptions.actions.resumed';

export const CANCEL_CONFIRM_TITLE = 'backoffice.subscriptions.actions.cancel_title';

export const CANCEL_NO_REFUND_NOTE = 'backoffice.subscriptions.actions.cancel_no_refund';

export const CANCEL_APPLIED_MESSAGE = 'backoffice.subscriptions.actions.cancelled';

export const RECURRING_ITEM_KEY = 'backoffice.subscriptions.actions.recurring_item';

export const TRIAL_APPLIED_MESSAGE = 'backoffice.subscriptions.trial.applied';

export const OVERRIDE_APPLIED_MESSAGE = 'backoffice.subscriptions.overrides.applied';

export const OVERRIDE_REVERTED_MESSAGE = 'backoffice.subscriptions.overrides.reverted';

export const OVERRIDE_REVERT_CONFIRM_TITLE = 'backoffice.subscriptions.overrides.revert_title';

export const OVERRIDE_REVERT_CONSEQUENCE =
  'backoffice.subscriptions.overrides.revert_consequence';

export const OVERRIDE_REVERT_AMOUNT_KEY = 'backoffice.subscriptions.overrides.revert_amount';

export const CONFIRM_NO_AMOUNT = 'backoffice.subscriptions.confirm.no_amount';

export const CONFIRM_BUTTON = 'backoffice.common.actions.confirm';
